"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-import-module-exports */
/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */
// Needed for redux-saga es6 generator support
require("@babel/polyfill");
var material_1 = require("@mui/material");
// Import all the third party stuff
var Sentry = __importStar(require("@sentry/react"));
var tracing_1 = require("@sentry/tracing");
var connected_react_router_1 = require("connected-react-router");
var en_CA_1 = __importDefault(require("date-fns/locale/en-CA"));
var setDefaultOptions_1 = __importDefault(require("date-fns/setDefaultOptions"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_firestore_1 = require("redux-firestore");
// Import root app
var theme_1 = __importDefault(require("common/theme"));
var App_1 = __importDefault(require("containers/App"));
var constants_1 = require("containers/App/constants");
var analytics_1 = __importStar(require("utils/analytics"));
var firebaseConf_1 = __importDefault(require("utils/firebaseConf"));
var history_1 = __importDefault(require("utils/history"));
// Import Language Provider
require("sanitize.css/sanitize.css");
// Load the favicon and the .htaccess file
/* eslint-disable import/no-unresolved, import/extensions */
require("!file-loader?name=[name].[ext]!./assets/images/user-avatar.png");
require("!file-loader?name=[name].[ext]!./assets/sw-2.js");
require("file-loader?name=.htaccess!./.htaccess");
// Load brand assets files
/* eslint-disable import/no-unresolved, import/extensions */
require("!file-loader?name=[name].[ext]!./assets/brand/hudled-logomark.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/hudled-loader.gif");
require("!file-loader?name=[name].[ext]!./assets/brand/generic-loader.gif");
require("!file-loader?name=[name].[ext]!./assets/brand/hudled-logo-color.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/hudled-logo-white.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/company-placeholder.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/company-placeholder_v2.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/tool-placeholder.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/Rechargly/rechargly-logo.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/Rechargly/rechargly-logo-grey.svg");
require("!file-loader?name=[name].[ext]!./assets/images/auxiliary/left-arrow.svg");
require("!file-loader?name=[name].[ext]!./assets/images/auxiliary/right-arrow.svg");
require("!file-loader?name=[name].[ext]!./assets/images/hudled-favicon.png");
require("!file-loader?name=[name].[ext]!./assets/images/rechargly-favicon-lt.png");
require("!file-loader?name=[name].[ext]!./assets/images/rechargly-favicon-dk.png");
require("!file-loader?name=[name].[ext]!./assets/images/404.png");
require("!file-loader?name=[name].[ext]!./assets/images/WorkInProgress.png");
require("!file-loader?name=[name].[ext]!./assets/images/google-logo.png");
require("!file-loader?name=[name].[ext]!./assets/images/SaaSAuditPrototype.png");
require("!file-loader?name=[name].[ext]!./assets/images/my-audit-score.png");
require("!file-loader?name=[name].[ext]!./assets/images/SaaSAudits.png");
require("!file-loader?name=[name].[ext]!./assets/images/HudledBenchmark.png");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/xero.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/xpm.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/quickbooks.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/myob.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/netsuiteOracle.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/sage.svg");
require("!file-loader?name=[name].[ext]!./assets/images/accountingSoftwares/finacialForce.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/GradientCheckmarkIcon.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/DiscountSplit.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/ShareOnline.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/PaymentMethod.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/RevertBlend.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/CheckboxBlend.svg");
require("!file-loader?name=[name].[ext]!./assets/images/emailProviders/Gmail.png");
require("!file-loader?name=[name].[ext]!./assets/images/emailProviders/Outlook.png");
require("!file-loader?name=[name].[ext]!./assets/images/emailProviders/GmailAutoFwd.gif");
require("!file-loader?name=[name].[ext]!./assets/images/emailProviders/OutlookAutoFwd.png");
require("!file-loader?name=[name].[ext]!./assets/images/XeroInvoiceEmail.png");
require("!file-loader?name=[name].[ext]!./assets/csvs/Xero_WizardBooks_INV-1234.csv");
require("!file-loader?name=[name].[ext]!./assets/csvs/AMS-7007-24-01-14.csv");
require("!file-loader?name=[name].[ext]!./assets/csvs/CustomCSVImport.csv");
require("!file-loader?name=[name].[ext]!./assets/images/icons/ShieldCheck.svg");
require("!file-loader?name=[name].[ext]!./assets/images/Stripe.svg");
require("!file-loader?name=[name].[ext]!./assets/images/icons/CircledFileSlash.svg");
require("!file-loader?name=[name].[ext]!./assets/images/not-my-stack.svg");
require("!file-loader?name=[name].[ext]!./assets/brand/Rechargly/icons/active-recharging.svg");
var configureStore_1 = __importDefault(require("./configureStore"));
// Import CSS reset and Global Styles
require("./global-styles");
if (!window.location.host.startsWith('localhost:')) {
    Sentry.init({
        dsn: window.location.host === 'app.hudled.com'
            ? 'https://1de995455c1943a6a73fdd90a5ae70cd@o456876.ingest.sentry.io/5450356'
            : 'https://45d06044a76a4ad09e334c221ec76e31@o456876.ingest.sentry.io/5450359',
        integrations: [
            new tracing_1.Integrations.BrowserTracing(),
        ],
        release: process.env.REACT_APP_RELEASE,
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
    });
}
var consoleError = console.error;
console.error = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // The pseudo class ":nth-last-child" is potentially unsafe when doing server-side rendering. Try changing it to ":nth-last-of-type".
    // The pseudo class ":first-child" is potentially unsafe when doing server-side rendering. Try changing it to ":first-of-type".
    // Warning: React does not recognize the `disableElevation` prop on a DOM element. If you intentionally want it to ... bug in MUI
    if ("".concat(args[0]).includes('potentially unsafe when doing server-side rendering')
        || ("".concat(args[0]).includes('Warning: React does not recognize the `%s` prop on a DOM element.') && args[1] === 'disableElevation')) {
        return undefined;
    }
    if ("".concat(args[0]).match(/^Warning|^MUI|potentially unsafe/)) {
        return console.warn.apply(console, __spreadArray([], __read(args), false));
    }
    return consoleError.apply(void 0, __spreadArray([], __read(args), false));
};
// Create redux store with history
var initialState = {};
var store = (0, configureStore_1.default)(initialState, history_1.default);
var MOUNT_NODE = document.getElementById('app');
(0, analytics_1.default)();
firebaseConf_1.default.auth().onAuthStateChanged(function (user) { return (0, analytics_1.identifySegment)(user); });
// react-redux-firebase config
var rrfProps = {
    firebase: firebaseConf_1.default,
    config: {
        userProfile: 'users',
        useFirestoreForProfile: true,
        profileParamsToPopulate: constants_1.PROFILE_POPULATES,
    },
    dispatch: store.dispatch,
    createFirestoreInstance: redux_firestore_1.createFirestoreInstance,
};
(0, setDefaultOptions_1.default)({ locale: en_CA_1.default });
var render = function () {
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(react_redux_1.Provider, __assign({ store: store }, { children: (0, jsx_runtime_1.jsx)(react_redux_firebase_1.ReactReduxFirebaseProvider, __assign({}, rrfProps, { children: (0, jsx_runtime_1.jsx)(connected_react_router_1.ConnectedRouter, __assign({ history: history_1.default }, { children: (0, jsx_runtime_1.jsx)(material_1.StyledEngineProvider, __assign({ injectFirst: true }, { children: (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, __assign({ theme: (0, theme_1.default)() }, { children: (0, jsx_runtime_1.jsx)(App_1.default, {}) })) })) })) })) })), MOUNT_NODE);
};
// Apparently works out of the box now... And including this code actually makes it not work
// if (module.hot) {
//   // Hot reloadable React components and translation json files
//   // modules.hot.accept does not accept dynamic dependencies,
//   // have to be constants at compile-time
//   module.hot.accept(['containers/App'], () => {
//     ReactDOM.unmountComponentAtNode(MOUNT_NODE as HTMLElement);
//     render();
//   });
// }
render();
